import { Fragment, FunctionComponent } from 'react';
import { Card, CardContent, Divider, Typography } from '@mui/material';
import { Customer } from '@/models/customer';
import { CardListRow } from '@/components/Card/CardListRow';

const customerKeyLabel: { [key in keyof Customer]?: string } = {
    email: 'E-Mail',
    firstname: 'Vorname',
    lastname: 'Nachname',
    salutation: 'Anrede',
    language: 'Sprache',
    phone: 'Telephon',
    city: 'Stadt',
    zipcode: 'PLZ',
    country: 'Land',
    street: 'Straße',
    title: 'Titel',
};

const customerKeySort: (keyof typeof customerKeyLabel)[] = [
    'email',
    'phone',
    'salutation',
    'title',
    'firstname',
    'lastname',
    'street',
    'city',
    'country',
];

type CustomerDetailsCardProps = {
    customer: Customer;
};

export const CustomerDetailsCard: FunctionComponent<
    CustomerDetailsCardProps
> = ({ customer }) => {
    return (
        <Card
            sx={{
                maxWidth: '640px',
            }}
        >
            <CardContent
                sx={{
                    bgcolor: 'divider',
                }}
            >
                <Typography variant='h6'>Kundendetails</Typography>
            </CardContent>
            <Divider
                sx={{
                    width: '100%',
                }}
            />

            {customerKeySort.map((key) => {
                const label = customerKeyLabel[key];
                const value = customer[key]?.toString() || '-';

                if (!label) return null;

                return (
                    <Fragment key={key}>
                        <CardListRow>
                            <Typography variant='subtitle2'>
                                {customerKeyLabel[key] || key}
                            </Typography>

                            <Typography
                                sx={{
                                    mt: 2,
                                    ml: 2,
                                }}
                            >
                                {value?.toString() || '-'}
                            </Typography>
                        </CardListRow>
                        <Divider
                            sx={{
                                width: '100%',
                            }}
                        />
                    </Fragment>
                );
            })}
        </Card>
    );
};
